/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AnnuityDetailsViewModel } from './AnnuityDetailsViewModel';
import {
    AnnuityDetailsViewModelFromJSON,
    AnnuityDetailsViewModelFromJSONTyped,
    AnnuityDetailsViewModelToJSON,
} from './AnnuityDetailsViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfAnnuityDetailsViewModel
 */
export interface ResultOfAnnuityDetailsViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfAnnuityDetailsViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfAnnuityDetailsViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfAnnuityDetailsViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfAnnuityDetailsViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfAnnuityDetailsViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfAnnuityDetailsViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfAnnuityDetailsViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {AnnuityDetailsViewModel}
     * @memberof ResultOfAnnuityDetailsViewModel
     */
    data?: AnnuityDetailsViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfAnnuityDetailsViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfAnnuityDetailsViewModel interface.
 */
export function instanceOfResultOfAnnuityDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfAnnuityDetailsViewModelFromJSON(json: any): ResultOfAnnuityDetailsViewModel {
    return ResultOfAnnuityDetailsViewModelFromJSONTyped(json, false);
}

export function ResultOfAnnuityDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfAnnuityDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : AnnuityDetailsViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfAnnuityDetailsViewModelToJSON(value?: ResultOfAnnuityDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': AnnuityDetailsViewModelToJSON(value.data),
        'Count': value.count,
    };
}

